import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import LiBeirut from '../views/LiBeirut.vue'
import AddDonations from '../components/LiBeirut/VenueDonationItem.vue'
import ActionPage from '../views/ActionPage.vue'
import ArtWorks from '../views/ArtFestival.vue'
import InitiativesDashboard from '../views/InitiativesDashboard.vue'
import InitiativesPage from '../views/InitiativesPage.vue'
import Dashboard from '../views/Dashboard.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/dashboard/initiative/LiBeirut',
    name: 'DashboardInitiative',
    component: InitiativesDashboard
  },{
    path: '/auth/initiative/LiBeirut',
    name: 'AuthPage',
    component: InitiativesPage
  }, {
    path: '/dashboard/LiBeirut/:init_name',
    name: 'initiativePage',
    component: Dashboard
  },{
    path: '/initiative/LiBeirut',
    name: 'initiativePage',
    component: InitiativesPage
  }, {
    path: '/action/LiBeirut',
    name: 'actionLiBeirut',
    component: ActionPage
  }, {
    path: '/ArtWorks',
    name: 'ArtWorks',
    component: ArtWorks,
   
    
    meta: {
      title: 'ARTWORKS',
      metaTags: [
        {
          name: 'description',
          content: 'Let’s weave the fabric of new beginnings'
        },
        {
          property: 'og:description',
          content: 'Let’s weave the fabric of new beginnings'
        },
        {
          property: 'og:site_name',
          content: 'ARTWORKS'
        },
        {
          property: 'og:title',
          content: 'ARTWORKS'
        }
      ]
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/LiBeirut',
    name: 'LiBeirut',
    component: LiBeirut
  }, {
    path: '/LiBeirut/AddDonations',
    name: 'AddDonations',
    component: AddDonations
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});


export default router
